import axios from 'axios';

// Ensure we never use port 8000
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // Important for HTTP cookies
    timeout: 10000, // 10 second timeout
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor
api.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle connection refused errors
        if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
            return Promise.reject({
                success: false,
                message: 'Unable to connect to server. Please try again later.'
            });
        }

        // Only redirect on 401 for non-auth API calls that are clearly protected.
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            const authPaths = ['/login', '/signup', '/forgot-password', '/verify-otp', '/change-password'];
            const isAuthAPI = error.config?.url?.includes('/auth/');
            const isCartAPI = error.config?.url?.includes('/cart');
            const isPublicProductRoute = currentPath.startsWith('/products');
            const isPublicCartRoute = currentPath.startsWith('/cart');
            const isPublicHomeRoute = currentPath === '/';

            // Don't redirect if we're on an auth page, making an auth API call,
            // using the cart API, or viewing a public guest-accessible page
            // (home feed, product detail, or cart). Those pages may fire other
            // API calls that aren't guest-safe, but a 401 from one of them
            // shouldn't kick a guest off a page they're allowed to be on.
            if (
                !authPaths.includes(currentPath) &&
                !isAuthAPI &&
                !isCartAPI &&
                !isPublicProductRoute &&
                !isPublicCartRoute &&
                !isPublicHomeRoute
            ) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;